import React from "react";
import { Link, redirect } from "react-router-dom";

import invariant from "tiny-invariant";

import TournamentsTable from "./Table";

import { tournamentManagementActions } from "../../features/tourneymgmt/tournamentManagementSlice";
import { useAppSelector } from "../../hooks/reduxHooks";
import { store } from "../../index";
import { AUTH_LEVELS } from "../../lib/globals";

export const loader = async ({ params }: { params: any }) => {
    const state = store.getState();
    const user = state.auth.user;
    const promises = [];
    const tournaments = state.tournamentmanagement.tournaments;
    let masterTournaments = state.tournamentmanagement.masterTournaments;

    !tournaments.length &&
        promises.push(
            store.dispatch(tournamentManagementActions.getTournaments()),
        );
    !masterTournaments.length &&
        promises.push(
            store.dispatch(tournamentManagementActions.getMasterTournaments()),
        );

    masterTournaments = store.getState().tournamentmanagement.masterTournaments;

    if (
        params.tournamentId &&
        user?.userLevel === 3 &&
        !masterTournaments
            .find(t => t.id === parseInt(params.tournamentId))
            ?.tournamentDirector?.flatMap(t => t.id)
            .includes(user.id)
    ) {
        return redirect("/tournament-management");
    }

    await Promise.all(promises);
    return null;
};

const TournamentManagementIndex = (): React.JSX.Element | undefined => {
    const { user } = useAppSelector(state => state.auth);
    invariant(user);

    return (
        <>
            {AUTH_LEVELS.sitemanagement.includes(user.userLevel) && (
                <Link
                    to={`/tournament-management/tournament/add`}
                    className="btn btn-primary createButton no-margin-btn"
                >
                    Add Tournament
                </Link>
            )}
            <TournamentsTable />
        </>
    );
};

export default TournamentManagementIndex;
